<template>
  <b-modal
    :hide-footer="true"
    :title="$t('Responder Encaminhamento')"
    centered
    size="md"
    id="cadastrar-resposta-encaminhamento"
  >
    <div class="row">
      <form-select
        v-if="substatus.length > 0"
        label="Motivo"
        :itens="substatus"
        v-model="motivo"
        :required="true"
        :loading="loadingMotivos"
      />

      <form-textarea
        v-model="observacoes"
        label="Descreva sua resposta"
        :required="true"
      />
    </div>

    <div class="row pt-4 px-2 d-flex justify-content-end">
      <button @click="submit" class="btn btn-success btn-submit">
        <i class="mdi mdi-content-save"></i>
        Salvar
      </button>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      dataNow: moment().format("YYYY/MM/DD"),
      motivo: "",
      observacoes: "",
      data: "",
      substatus: [],
      status_pai: 2,
      loadingMotivos: false,
      modulo: "Encaminhamento",
      model: "Encaminhamento",
      status: {},
    };
  },
  created() {
    this.getSubStatus(this.status_pai);
  },
  mounted() {
    this.getStatusFinais();
  },
  methods: {
    getStatusFinais() {
      axios
        .post(`api/dashboard/get/status/finais`, {
          model: this.model,
          module: this.modulo,
        })
        .then((response) => {
          this.status = response.data;
        });
    },
    getSubStatus(status) {
      this.loadingMotivos = true;
      axios
        .post(`api/dashboard/admin/getSubStatus`, {
          status_pai: status,
          module: this.modulo,
          model: this.model,
        })
        .then((response) => {
          this.substatus = response.data;
          this.loadingMotivos = false;
        });
    },
    submit() {
      axios
        .post("api/dashboard/status/historico", {
          id: this.item.id,
          observacoes: this.observacoes,
          motivo: this.motivo,
          status_anterior: this.item.status,
          status_atual: 2,
          data: this.data,
          module: this.modulo,
          model: this.model,
        })
        .then((response) => {
          this.$emit("submit", "historico");
          this.$root.$emit("newhistorico");
          this.$snack.success({
            button: false,
            text: "Histórico salvo com sucesso.",
          });
          this.load = false;
        })
        .finally(() => {
          this.observacoes = "";
          this.motivo = "";
          this.data = "";

          this.$bvModal.hide("status-historico-" + this.model);
        });
    },
  },
};
</script>
